export const PROGRESS_DETAILS_REQUEST = 'PROGRESS_DETAILS_REQUEST';
export const PROGRESS_DETAILS_SUCCESS = 'PROGRESS_DETAILS_SUCCESS';
export const PROGRESS_DETAILS_FAIL = 'PROGRESS_DETAILS_FAIL';

export const RECORD_GRADE_REQUEST = 'RECORD_GRADE_REQUEST';
export const RECORD_GRADE_SUCCESS = 'RECORD_GRADE_SUCCESS';
export const RECORD_GRADE_FAIL = 'RECORD_GRADE_FAIL';
export const RECORD_GRADE_RESET = 'RECORD_GRADE_RESET';

export const USER_GRADE_REQUEST = 'USER_GRADE_REQUEST';
export const USER_GRADE_SUCCESS = 'USER_GRADE_SUCCESS';
export const USER_GRADE_FAIL = 'USER_GRADE_FAIL';

export const CHANGE_USER_LEVEL_REQUEST = 'CHANGE_USER_LEVEL_REQUEST';
export const CHANGE_USER_LEVEL_SUCCESS = 'CHANGE_USER_LEVEL_SUCCESS';
export const CHANGE_USER_LEVEL_FAIL = 'CHANGE_USER_LEVEL_FAIL';

export const MAKE_ME_A_TUROR_REQUEST = 'MAKE_ME_A_TUROR_REQUEST';
export const MAKE_ME_A_TUROR_SUCCESS = 'MAKE_ME_A_TUROR_SUCCESS';
export const MAKE_ME_A_TUROR_FAIL = 'MAKE_ME_A_TUROR_FAIL';
